import Style from './panelStyles.module.scss';
import { useNode } from '@craftjs/core';
import { PanelContainer } from './uiKit/panelContainer/panelContainer';
import { hasSection } from './helpers/helper';
import { ControlsGroup } from './uiKit/controlsGroup/controlsGroup';
import { SettingsInput } from './uiKit/input/settingsInput';
import { FormFieldWithScoreProps, ValidationProps } from '../../types/BaseControlTypes';
import { useScopedTranslation } from 'src/application/localisation/useScopedTranslation';
import { AppCheckboxInput } from 'uikit/inputs';

type ValidationPanelSection = 'MinMax' | 'MaxLength' | 'Pattern' | 'DateRange';

export type ValidationPanelProps = {
  type?: 'text' | 'number' | 'date';
  sections?: ValidationPanelSection[];
};

export const ValidationPanel = ({ sections, type }: ValidationPanelProps) => {
  const { t } = useScopedTranslation('GeneralFormBuilder.Panels.Validation');
  const {
    actions: { setProp },
    props,
  } = useNode((node) => ({
    props: node.data.props as ValidationProps,
  }));

  return (
    <PanelContainer header={t('Header')} panelName="Validation">
      {!hasSection<ValidationPanelSection>(sections, 'DateRange') && (
        <ControlsGroup contentClassName={Style.flexContainer}>
          <AppCheckboxInput
            label={t('IsOptional')}
            checked={props.isOptional}
            onChange={(e) =>
              setProp((p: ValidationProps & FormFieldWithScoreProps) => {
                p.isOptional = e.target.checked || undefined;
                if (!e.target.checked) p.noAnswerScore = undefined;
              }, 500)
            }
          />
        </ControlsGroup>
      )}

      {hasSection<ValidationPanelSection>(sections, 'DateRange') && (
        <ControlsGroup contentClassName={Style.flexContainer}>
          <AppCheckboxInput
            label={t('StartDateIsOptional')}
            checked={props.startDateIsOptional}
            onChange={(e) =>
              setProp((p: ValidationProps) => {
                p.startDateIsOptional = e.target.checked || undefined;
              }, 500)
            }
          />
          <AppCheckboxInput
            label={t('EndDateIsOptional')}
            checked={props.endDateIsOptional}
            onChange={(e) =>
              setProp((p: ValidationProps) => {
                p.endDateIsOptional = e.target.checked || undefined;
              }, 500)
            }
          />
        </ControlsGroup>
      )}

      {hasSection<ValidationPanelSection>(sections, 'MinMax') && (
        <ControlsGroup header={t('MinMax')} contentClassName={Style.gridContainer}>
          <SettingsInput
            type={type}
            placeholder={t('MinValue')}
            value={props.minValue}
            onChange={(e) =>
              setProp((p: ValidationProps) => {
                p.minValue = e.target.value || undefined;
              }, 500)
            }
          />
          <SettingsInput
            type={type}
            placeholder={t('MaxValue')}
            value={props.maxValue}
            onChange={(e) =>
              setProp((p: ValidationProps) => {
                p.maxValue = e.target.value || undefined;
              }, 500)
            }
          />
        </ControlsGroup>
      )}

      {hasSection<ValidationPanelSection>(sections, 'MaxLength') && (
        <ControlsGroup header={t('MaxLength')} contentClassName={Style.flexContainer}>
          <SettingsInput
            type={'number'}
            placeholder={t('MaxLengthPlaceholder')}
            value={props.maxLength}
            onChange={(e) =>
              setProp((p: ValidationProps) => {
                p.maxLength = +e.target.value || undefined;
              }, 500)
            }
          />
        </ControlsGroup>
      )}

      {hasSection<ValidationPanelSection>(sections, 'Pattern') && (
        <ControlsGroup header={t('ReGex')} contentClassName={Style.flexContainer}>
          <SettingsInput
            placeholder={t('ReGexPlaceholder')}
            value={props.pattern}
            onChange={(e) =>
              setProp((p: ValidationProps) => {
                p.pattern = e.target.value || undefined;
              }, 500)
            }
          />
        </ControlsGroup>
      )}
    </PanelContainer>
  );
};
